import {createAction} from 'redux-actions';
import {
    getUserData,
    getTextEnums,
} from '@pluto/rest';
import {LoginActionParams} from '../LoginTypes';

export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const GET_TEXT_ENUMS = 'GET_TEXT_ENUMS';
export const LOGIN_START = 'LOGIN_START';
export const LOGOUT_START = 'LOGOUT_START';

export const logInAction = createAction(LOG_IN, async (params: LoginActionParams) => {
    const {jwt} = params;
    const {
        status,
        email,
        name,
        roles,
    } = await getUserData();

    return {
        jwt,
        status,
        email,
        name,
        roles,
    };
});

export const getTextEnumsAction = createAction(GET_TEXT_ENUMS, async () => {
    return await getTextEnums();
});

export const logOutAction = createAction(LOG_OUT);
